import { StyleProp, ViewStyle } from 'react-native';
import { grid } from '@shared/styles';

export const personCollectionViewFieldStyles: StyleProp<ViewStyle> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  flexWrap: 'wrap',
  marginLeft: -grid(0.75),
};
